import { asArray, asBoolean, asId, asObject, asText } from "../coerce";
import type {
  SurveyApiItem,
  SurveyItem,
  SurveysApiResponse,
} from "../../../@types/portalAluno";

const asSafeExternalUrl = (value: unknown) => {
  const text = asText(value);
  if (!text) return undefined;

  try {
    const url = new URL(text, window.location.origin);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.href
      : undefined;
  } catch {
    return undefined;
  }
};

const mapEvaluation = (item: SurveyApiItem): SurveyItem | undefined => {
  const id = asId(item.idAvaliacao);
  const title = asText(item.nmAvaliacao);
  if (!id || !title) return undefined;

  return {
    completed: asBoolean(item.isRealizado),
    description: asText(item.dsAvaliacao),
    id,
    kind: "evaluation",
    title,
  };
};

const mapExternalSurvey = (item: SurveyApiItem): SurveyItem | undefined => {
  const id = asId(item.idUrlExterna);
  const title = asText(item.nmUrlExterna);
  if (!id || !title) return undefined;

  return {
    completed: false,
    description: asText(item.dsUrlExterna),
    externalUrl: asSafeExternalUrl(item.linkUrlExterna),
    id,
    kind: "external",
    title,
  };
};

export const mapSurveysResponse = (value: unknown): SurveyItem[] => {
  const response = asObject<SurveysApiResponse>(value);
  if (!response) {
    throw new Error("A API retornou uma lista de enquetes inválida.");
  }

  return [
    ...asArray<SurveyApiItem>(response.enquetes).flatMap((item) => {
      const survey = mapEvaluation(item);
      return survey ? [survey] : [];
    }),
    ...asArray<SurveyApiItem>(response.pesquisas).flatMap((item) => {
      const survey = mapExternalSurvey(item);
      return survey ? [survey] : [];
    }),
  ];
};
